module.exports = __webpack_public_path__ + "static/media/logo.02d2a67a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 93
// module chunks = 4